<template>
  <v-card class="pa-2" style="overflow-y: auto;">
    <block v-if="loading" />


    <GeneralFilter
      class="mt-0"
      :breakline="true"
      :filterEndpoint="$API.customers.getPaymentsProductsServicesReport"
      :columnsFilterEndpoint="$API.customers.getPaymentsProductsServicesReport"
      :search="search"
      :columns.sync="columnsSearch"
      :advancedFilter="true"
      prefixColumn
      :hideSearch="true"
      :isAutoScrolled="true"
      :hideLimitLabel="true"
      :showBranchSelector="true"
      :selectedBranch="selectedBranch"
      :branches="branches"
      :currentBranch="currentBranch"
      @onBranchChange="onBranchChange"
      @emptyFilter="clearData"
      @filtered="filterHandler"
      @loading="loading = $event"
    >
      <template #complementFilters>
        <v-row class="mb-1 mt-4">
          <v-col cols="12" md="6">
            <v-card outlined class="pa-3">
              <div class="text-subtitle-2 mb-2">Modo de reporte</div>
              <v-radio-group v-model="search.paymentStatusMode" row hide-details="auto" class="mt-0">
                <v-radio label="Mostrar todos" value="all" />
                <v-radio label="Solo pagos completos" value="complete" />
              </v-radio-group>
            </v-card>
          </v-col>
          <v-col cols="12" md="6" class="pt-0">
            <v-card outlined class="pa-3">
              <div class="text-subtitle-2 mb-2">Agrupar por</div>
              <v-radio-group v-model="groupMode" row hide-details="auto" class="mt-0">
                <v-radio label="Sin agrupar" value="none" />
                <v-radio label="Comprobante" value="invoice" />
                <v-radio label="Vendedor" value="seller" />
                <v-radio label="Producto/servicio" value="item" />
              </v-radio-group>
            </v-card>
          </v-col>
        </v-row>
      </template>
      <DxDataGrid
        ref="gridRef"
        :dataSource="rows"
        :showBorders="true"
        :column-auto-width="true"
        :scrolling="{ useNative: true }"
        :grouping="{ autoExpandAll: true }"
        @exporting="onExporting"
        style="max-height: 700px;"
      >
        <DxExport :enabled="true" />
        <DxColumnChooser
          :enabled="true"
          mode="select"
          title="Columnas visibles"
          :height="400"
          :width="400"
        />
        <DxStateStoring
          :enabled="true"
          type="localStorage"
          storage-key="conf_abonos_productos_servicios_grid"
        />
        <DxColumn dataField="UltimaFechaPagoISO" caption="Fecha del abono" data-type="date" sort-order="desc" cell-template="date-cell" />
        <DxColumn dataField="Receipts" caption="Recibo(s)" />
        <DxColumn dataField="ID_Customer" caption="ID Cliente" />
        <DxColumn dataField="LegalName" caption="Nombre del cliente" />
        <DxColumn dataField="AdditionalInformation" :caption="additionalInformationTitle" />
        <DxColumn dataField="FullNameSeller" caption="Nombre del vendedor" :group-index="groupMode === 'seller' ? 0 : undefined" />
        <DxColumn dataField="ID_Invoice" caption="ID de comprobante" :group-index="groupMode === 'invoice' ? 0 : undefined" />
        <DxColumn dataField="ItemTypeDescription" caption="Tipo" />
        <DxColumn dataField="ID_Item" caption="Código del producto" />
        <DxColumn dataField="ItemDescription" caption="Producto/servicio" :group-index="groupMode === 'item' ? 0 : undefined" />
        <DxColumn dataField="ItemQuantity" caption="Cantidad" />
        <DxColumn dataField="ItemUnitPrice" caption="Precio" cell-template="money-cell" />
        <DxColumn dataField="Total" caption="Total" cell-template="money-cell" />
        <DxColumn dataField="InvoiceTotalPagar" caption="Total del comprobante" cell-template="money-cell" />
        <DxColumn dataField="TotalAbonos" caption="Abono" cell-template="money-cell" />
        <DxColumn dataField="SaldoAnterior" caption="Saldo anterior" cell-template="money-cell" />
        <DxColumn dataField="SaldoActual" caption="Saldo actual" cell-template="money-cell" />
        <DxColumn dataField="BranchName" caption="Sucursal" />
        <DxColumn dataField="NumeroControl" caption="Número de control" />
        <DxColumn dataField="CodigoGeneracion" caption="Código de generación" />
        <DxPager :showPageSizeSelector="true" />
        <DxPaging :defaultPageSize="10" />

        <template #date-cell="{ data }">
          <span>{{ formatDate(data.data.UltimaFechaPagoISO || data.data.UltimaFechaPago) }}</span>
        </template>
        <template #money-cell="{ data }">
          <span>{{ formatMoney(data.value) }}</span>
        </template>
      </DxDataGrid>
    </GeneralFilter>
  </v-card>
</template>

<script>
import Block from "@/components/Block";
import GeneralFilter from "@/components/GeneralFilter";
import { DxDataGrid, DxColumn, DxExport, DxPager, DxPaging, DxColumnChooser, DxStateStoring } from "devextreme-vue/data-grid";
import { printToExcel } from "@/helpers/printToexcel";
import { numberWithCommas } from "@/helpers/money";
import moment from "moment";

export default {
  name: "AccountsReceivablePaymentsProductsServices",
  components: {
    Block,
    GeneralFilter,
    DxDataGrid,
    DxColumn,
    DxExport,
    DxPager,
    DxPaging,
    DxColumnChooser,
    DxStateStoring,
  },
  props: ["win"],
  data() {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    const additionalInformationTitle = Number(user.IsOptical) === 1 ? "Lugar de trabajo" : "Información adicional";
    const lockedCustomerId = this.win?.meta?.customerToShow?.ID_Customer || "";

    return {
      loading: false,
      additionalInformationTitle,
      rows: [],
      branches: [],
      currentBranch: "Todas las sucursales",
      selectedBranch: 0,
      currency: JSON.parse(localStorage.getItem("branch") || "{}").Currency || "$",
      customerLocked: !!lockedCustomerId,
      search: {
        typeData: "01",
        paymentStatusMode: "all",
        reportBranch: 0,
        contextCustomerId: lockedCustomerId,
      },
      groupMode: "none",
      columnsSearch: [
        {
          name: "startDate",
          title: "Fecha inicio",
          value: "",
          type: "date",
        },
        {
          name: "endDate",
          title: "Fecha fin",
          value: "",
          type: "date",
        },
        ...(lockedCustomerId
          ? []
          : [
              {
                name: "ID_Customer",
                title: "ID Cliente",
                value: "",
                type: "text",
              },
            ]),
        {
          name: "InvoiceName",
          title: "Nombre del cliente",
          value: "",
          type: "text",
        },
        {
          name: "AdditionalInformation",
          title: additionalInformationTitle,
          value: "",
          type: "text",
        },
        {
          name: "ID_Invoice",
          title: "ID Factura",
          value: "",
          type: "text",
        },
        {
          name: "ItemDescription",
          title: "Producto o servicio",
          value: "",
          type: "text",
        },
        {
          name: "ID_Seller",
          title: "Vendedor",
          value: "",
          type: "select",
          options: [],
        },
      ],
      userBusinessId: user.businessid || "",
      userBranchId: user.branch || 0,
    };
  },
  mounted() {
    this.getBranches();
    this.getSellers();
  },
  methods: {
    async getBranches() {
      try {
        const branches = await this.$API.branches.findBranches(this.userBusinessId);
        const allOption = { ID_Branch: 0, BranchName: "Todas las sucursales" };
        this.branches = [allOption, ...(Array.isArray(branches) ? branches : [])];

        const current = this.branches.find((branch) => branch.ID_Branch == this.userBranchId);
        if (current) {
          this.selectedBranch = current.ID_Branch;
          this.currentBranch = current.BranchName;
          this.search.reportBranch = current.ID_Branch;
        } else {
          this.selectedBranch = 0;
          this.currentBranch = "Todas las sucursales";
          this.search.reportBranch = 0;
        }
      } catch (error) {
        this.branches = [{ ID_Branch: 0, BranchName: "Todas las sucursales" }];
        this.selectedBranch = 0;
        this.currentBranch = "Todas las sucursales";
        this.search.reportBranch = 0;
      }
    },
    async getSellers() {
      try {
        const response = await this.$API.sellers.getAllSellers();
        const sellers = Array.isArray(response)
          ? response.map((seller) => ({
              name: seller.FullName || `${seller.FirstName || ""} ${seller.LastName || ""}`.trim(),
              value: seller.ID_Seller,
            }))
          : [];

        this.setColumnOptions("ID_Seller", sellers);
      } catch (error) {
        this.setColumnOptions("ID_Seller", []);
      }
    },
    setColumnOptions(columnName, options) {
      const index = this.columnsSearch.findIndex((column) => column.name === columnName);
      if (index === -1) return;

      const nextColumns = [...this.columnsSearch];
      nextColumns[index] = {
        ...nextColumns[index],
        options,
      };
      this.columnsSearch = nextColumns;
    },
    onBranchChange(value) {
      const normalizedValue = value === null || value === undefined || value === "" ? 0 : value;
      this.selectedBranch = normalizedValue;
      this.search.reportBranch = normalizedValue;

      const selected = this.branches.find((branch) => branch.ID_Branch == normalizedValue);
      this.currentBranch = selected ? selected.BranchName : "Todas las sucursales";
    },
    clearData() {
      this.rows = [];
    },
    filterHandler(response) {
      const rows = Array.isArray(response) ? response : response?.details || [];
      this.rows = rows.map((row) => ({
        ...row,
        ItemUnitPrice: Number(row.ItemUnitPrice || 0),
        Total: (Number(row.ItemUnitPrice || 0) * Number(row.ItemQuantity || 0))
          + (["CCF", "DNC"].includes(String(row.InvoiceType || "").toUpperCase()) ? Number(row.ItemIVA || 0) : 0),
        TotalLinea: Number(row.TotalLinea || 0),
        TotalAbonos: Number(row.TotalAbonos || 0),
        SaldoAnterior: Number(row.SaldoAnterior || 0),
        SaldoActual: Number(row.SaldoActual || 0),
        InvoiceTotalPagar: Number(row.InvoiceTotalPagar || 0),
      }));
    },
    formatMoney(value) {
      return `${this.currency}${numberWithCommas(Number(value || 0).toFixed(2))}`;
    },
    formatDate(value) {
      if (!value) return "";
      const parsed = moment(value, ["YYYY-MM-DD", "DD/MM/YYYY", moment.ISO_8601], true);
      if (!parsed.isValid()) {
        return value;
      }
      return parsed.format("DD/MM/YYYY");
    },
    onExporting(e) {
      printToExcel(e, "Abonos por productos y servicios");
    },
    openColumnChooser() {
      const grid = this.$refs.gridRef?.instance;
      if (grid && typeof grid.showColumnChooser === "function") {
        grid.showColumnChooser();
      }
    },
  },
};
</script>

<style scoped>
</style>
